import { Button, ButtonGroup, FormLabel, ModalBody, ModalFooter, Radio, RadioGroup, SelectionControlLabel, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { quickbooksLogin } from '../../../../api/oms/order-history';
import { pushErrorEvent, pushEventInfo, setPageInfoWithEvent, } from '../../../../utils/analytics';
import { getWindow } from '../../../../utils/general';
import { pushQuickBookExportEvent } from '../../../../utils/purchase-history/analytics';
var handleSuccessOnlineRequest = function (response, setOpenModal) {
    var _a, _b;
    var qbLoginUrl = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.atob(response.data.qbLoginUrl);
    setOpenModal(false);
    var qbWindow = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.open(qbLoginUrl, 'QuickBooks Login', 'top=0,left=0,height=650px,width=auto,scrollbars=yes,resizable=yes,noopener,noreferrer');
    if (qbWindow) {
        qbWindow.opener = null;
    }
};
var handleFailureOnlineRequest = function (error, setAlertState, setOpenModal) {
    pushErrorEvent('purchase history quickbooks online export', error.code || '', error.message, 'inline');
    setAlertState({
        status: 'error',
        alertMessage: 'We ran into a problem, please try again.',
    });
    setOpenModal(false);
};
var QuickBooksLoginPassAnalytics = function () {
    pushEventInfo({
        category: { primaryCategory: 'my account' },
        eventInfo: { eventName: 'my account>purchase history' },
        myAccount: { settings: 'my account>purchase history>quickbooks sync pass' },
    });
    setPageInfoWithEvent('account', 'account>purchase history', 'account>purchase history>quickbooks sync complete', 'account>purchase history>quickbooks sync complete', 'maml:orders', 'quickbooks sync pass');
};
var QuickBooksLoginFailAnalytics = function () {
    pushEventInfo({
        category: { primaryCategory: 'my account' },
        eventInfo: { eventName: 'my account>purchase history' },
        myAccount: { settings: 'my account>purchase history>quickbooks sync fail' },
    });
    setPageInfoWithEvent('account', 'account>purchase history', 'account>purchase history>quickbooks sync fail', 'account>purchase history>quickbooks sync fail', 'maml:orders', 'quickbooks sync fail');
};
var handleOnlineExportClick = function (request, qbExportValue, setOpenModal, setAlertState) {
    var updatedRequest = request;
    if (qbExportValue === 'details') {
        updatedRequest.includeDetails = true;
    }
    var wrappedRequest = { orderHistoryRequest: updatedRequest };
    pushQuickBookExportEvent("purchase history: quickbooks export online ".concat(qbExportValue));
    quickbooksLogin(wrappedRequest)
        .then(function (response) {
        handleSuccessOnlineRequest(response, setOpenModal);
        QuickBooksLoginPassAnalytics();
    })
        .catch(function (error) {
        QuickBooksLoginFailAnalytics();
        handleFailureOnlineRequest(error, setAlertState, setOpenModal);
    });
};
var QuickBooksOnlineExport = function (props) {
    var setQBRenderFlag = props.setQBRenderFlag, request = props.request, setOpenModal = props.setOpenModal, setAlertState = props.setAlertState;
    var _a = useState(), radioValue = _a[0], setRadioValue = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBody, null,
            React.createElement(FormLabel, { id: "online-qb-export-radio-buttons-group-label" }, "Select data to export:"),
            React.createElement(RadioGroup, { "aria-labelledby": "online-qb-export-radio-buttons-group-label", name: "online-qb-export-radio-buttons-group", value: radioValue, onChange: function (event) {
                    setRadioValue(event.target.value);
                } },
                React.createElement(SelectionControlLabel, { value: "summary", label: "Summary Data" },
                    React.createElement(Radio, null)),
                React.createElement(SelectionControlLabel, { value: "details", label: "Details Data" },
                    React.createElement(Radio, null)))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: function () {
                        setQBRenderFlag(undefined);
                    } }, "Go Back"),
                React.createElement(Button, { disabled: radioValue === undefined, onClick: function () {
                        return handleOnlineExportClick(request, radioValue, setOpenModal, setAlertState);
                    } }, "Submit")))));
};
export default QuickBooksOnlineExport;
